/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfLineTextReviewUpsertResultDto } from '../../models/platform-api-result-of-line-text-review-upsert-result-dto';
import { PlatformUpsertLineTextReview } from '../../models/platform-upsert-line-text-review';

export interface PostLineTextReviewsActionUpsert$Params {
      body: PlatformUpsertLineTextReview
}

export function postLineTextReviewsActionUpsert(http: HttpClient, rootUrl: string, params: PostLineTextReviewsActionUpsert$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfLineTextReviewUpsertResultDto>> {
  const rb = new RequestBuilder(rootUrl, postLineTextReviewsActionUpsert.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfLineTextReviewUpsertResultDto>;
    })
  );
}

postLineTextReviewsActionUpsert.PATH = '/api/line-text-reviews/action/upsert';
